/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerTakeToModerationMutationResponse,
  TelegramProductsModeratorControllerTakeToModerationPathParams,
  TelegramProductsModeratorControllerTakeToModeration400,
  TelegramProductsModeratorControllerTakeToModeration401,
  TelegramProductsModeratorControllerTakeToModeration404,
  TelegramProductsModeratorControllerTakeToModeration409,
} from '../types/TelegramProductsModeratorControllerTakeToModeration.ts';

function getTelegramProductsModeratorTakeToModerationUrl(
  id: TelegramProductsModeratorControllerTakeToModerationPathParams['id'],
) {
  const res = { method: 'PATCH', url: `/api/moderator/telegram/products/take/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/take/:id}
 */
export async function telegramProductsModeratorTakeToModeration(
  id: TelegramProductsModeratorControllerTakeToModerationPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsModeratorControllerTakeToModerationMutationResponse,
    ResponseErrorConfig<
      | TelegramProductsModeratorControllerTakeToModeration400
      | TelegramProductsModeratorControllerTakeToModeration401
      | TelegramProductsModeratorControllerTakeToModeration404
      | TelegramProductsModeratorControllerTakeToModeration409
    >,
    unknown
  >({ method: 'PATCH', url: getTelegramProductsModeratorTakeToModerationUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
